import { ref } from 'vue'

const scrollPosition = ref(0)
const lockCount = ref(0)

export const useScrollLock = () => {
  const activateScrollLock = () => {
    lockCount.value += 1

    if (lockCount.value > 1) return

    scrollPosition.value = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `${-scrollPosition.value}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  }

  const deactivateScrollLock = () => {
    lockCount.value = Math.max(lockCount.value - 1, 0)

    if (lockCount.value > 0) return
    if (document.body.style.position !== 'fixed') return

    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
    window.scrollTo(0, scrollPosition.value)
  }

  return { activateScrollLock, deactivateScrollLock }
}
